import { Guide } from "@/pages/catalogs/models/Guide";
import { MenuOptionType } from "@dexteel/mesf-core";
import { DeleteSweep } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

type Props = {
	setSelectedRowData: (guide: Guide) => void;
	setShowModal: (
		modal: "create" | "update" | "delete" | "deleteMultiple" | "",
	) => void;
};
export const useGuideOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: Guide | any) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Guide",
				key: "new_guide",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Guide",
					key: "edit_guide",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Guide",
					key: "delete_guide",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
				...(data.selectedRows.length > 1
					? [
							{
								name: `Delete selected (${data.selectedRows.length})`,
								key: "delete_selected_guides",
								onClick: () => {
									setShowModal("deleteMultiple");
								},
								icon: <DeleteSweep />,
							},
						]
					: []),
				{
					name: "Duplicate Guide",
					key: "duplicate_guide",
					onClick: () => {
						setSelectedRowData({
							...data,
							PartName: `${data.PartName} (Copy)`,
							RFIDTag: null,
							IsDuplicate: true,
						});
						setShowModal("create");
					},
					icon: <ContentCopyIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
